export default __webpack_public_path__ + "static/media/well-there-it-is.afdc371a.gif";